export default {
  root: {
    padding: 0,
    '&:last-child': {
      marginBottom: 0
    }
  },
};
